import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RedirectionAddressesComponent } from './redirection-addresses.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddRedirectionComponent } from './add-redirection/add-redirection.component';
import { EditRedirectionComponent } from './edit-redirection/edit-redirection.component';

@NgModule({
    declarations: [RedirectionAddressesComponent, AddRedirectionComponent, EditRedirectionComponent],
    imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule],
    exports: [RedirectionAddressesComponent],
})
export class RedirectionAddressesModule { }
